import { parseFrontendEnv, type AppEnv } from './envSchema';

// Eager validation at bundle load. In the Vite build `import.meta.env` is the
// inlined object of VITE_* values; a failure throws loudly rather than booting
// a misconfigured app. The schema itself lives in `envSchema.ts` (pure, tested).
const parsed = parseFrontendEnv(import.meta.env);

if (!parsed.success) {
  console.error('[env] invalid frontend env:', JSON.stringify(parsed.error.issues, null, 2));
  throw new Error('Invalid frontend env. See VITE_* in .env.example');
}

export const env: AppEnv = parsed.data;

export const hereMapsConfigured = Boolean(env.VITE_HERE_API_KEY);

/** PR-ONB-RESUME-1B — resumable-area FE flag (default off). */
export const resumableAreaEnabled =
  env.VITE_ONBOARDING_RESUMABLE_ENABLED === 'true';

export type { AppEnv };
